/** A cost as chips, one per resource it takes: what you have of what it needs (or just the need, small); without end, ∞. */
import type { Cost, Pockets } from '@bramvasterd/terrella-rules';
import type { JSX } from 'react';

import { costEntries } from '@game/planet/pockets';
import { ResourceIcon } from '@ui/icons';

import './cost.css';

const count = (n: number): string => (Number.isFinite(n) ? String(n) : '∞');

export function CostChips({
  cost,
  have,
  mini = false,
}: {
  cost: Cost;
  have: Readonly<Pockets>;
  /** Small, with the need only: for the main button. */
  mini?: boolean;
}): JSX.Element {
  return (
    <span className={`cost${mini ? ' mini' : ''}`}>
      {costEntries(cost).map(([resource, need]) => (
        <span key={resource} className={`chip ${have[resource] >= need ? 'ok' : 'short'}`}>
          <ResourceIcon kind={resource} />
          {mini ? need : `${count(have[resource])}/${need}`}
        </span>
      ))}
    </span>
  );
}
